export default "__VITE_ASSET__D8Nm5$7Q__"